import { createFileRoute, redirect } from '@tanstack/react-router'
import { AccountingPeriodsScreen } from '@/features/accounting/periods-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/periods')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_period_lock.create')) {
      throw redirect({ to: '/accounting' })
    }
  },
  component: AccountingPeriodsScreen,
})
